import { createFeatureSelector } from 'modules/store'

import { isPresent } from '../../../app/shared'
import * as fromSuggest from './suggest-adapter.actions'
import { SuggestData } from './types'

export type State = Record<string, SuggestData>

export const STORE_ID = 'suggest'
export const initialState: State = {}

export const reducer = (state = initialState, action: fromSuggest.default): State => {
  switch (action.type) {
    case fromSuggest.GET_SUGGEST_DATA: {
      const { storeId } = action.payload

      return {
        ...state,
        [storeId]: {
          data: [],
          isLoading: true,
        },
      }
    }

    case fromSuggest.GET_SUGGEST_DATA_SUCCESS: {
      const { storeId, data } = action.payload
      const newSubstate = {
        [storeId]: {
          isLoading: false,
          data,
        } as SuggestData,
      }

      return {
        ...state,
        ...newSubstate,
      }
    }

    case fromSuggest.CLEAN_SUGGEST_DATA: {
      const storeId = action.payload
      const newState = Object.keys(state).reduce((acc, substoreId) => {
        if (substoreId === storeId) {
          return acc
        }

        return {
          ...acc,
          [substoreId]: state[substoreId],
        }
      }, {})

      return newState
    }

    default:
      return state
  }
}

export const getSuggestData = <T>(state: State, storeId: string, normalizeFn: (data: any[]) => T) =>
  normalizeFn(getSuggestStore(state[storeId]).data)

export const getSuggestLoading = (state: State, storeId: string) => getSuggestStore(state[storeId]).isLoading

export const selectSuggestState = createFeatureSelector<State>(STORE_ID)

function getSuggestStore(suggestData: SuggestData): SuggestData {
  if (isPresent(suggestData)) {
    if (!isPresent(suggestData.data)) {
      return {
        ...suggestData,
        data: [],
      }
    }

    if (!isPresent(suggestData.isLoading)) {
      return {
        ...suggestData,
        isLoading: false,
      }
    }

    return suggestData
  }

  return {
    isLoading: false,
    data: [],
  }
}



// WEBPACK FOOTER //
// ./src/modules/forms/suggest-adapter/suggest-adapter.reducer.ts